export const API_SERVICE_TYPES = {
  MOWING: 'mowing',
  FERTILIZATION: 'fertilization',
  BUSHTRIMMING: 'bushtrimming',
  BED_WEEDING: 'bed_weeding',
  MULCHING: 'mulching',
  CLEANUP: 'cleanup_spring',
  LEAF_REMOVAL: 'cleanup_leaves',
  TREE_CARE: 'treecare',
  OTHER: 'other',
  AERATION: 'aeration',
  AERATION_OVERSEEDING: 'aeration_overseeding_package',
  FIREANT: 'fireanttreatment',
  GRUB: 'grubtreatment',
  CHINCH: 'chinch',
  DISEASE_FUNGICIDE: 'disease_fungicide',
  LIME: 'lime',
  MOSQUITO: 'mosquito',
};

export const API_SCHEDULE_TYPES = {
  SERVICE: 'service',
  MANUALQUOTE: 'manualquote',
  INSTANTQUOTE: 'instant_quote',
};

export const API_SCHEDULE_STATUSES = {
  CANCELLED: 'cancelled',
  ACTIVE: 'active',
  PENDING: 'pending',
  ENDED: 'ended',
};

export const API_SCHEDULE_FINAL_STATUSES = [
  API_SCHEDULE_STATUSES.CANCELLED,
  API_SCHEDULE_STATUSES.ENDED,
];
